import React from "react";
import { Container, Typography, Box } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";

import { LoadingViewProps } from "../../interface/LoadingViewProps";

const LoadingView = ({
  loading,
  data,
  notFoundMessage = "Not found",
  children,
}: LoadingViewProps) => {
  if (loading) {
    return (
      <Container>
        <Box display="flex" justifyContent="center" mt={4}>
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  if (!data) {
    return (
      <Container>
        <Typography>{notFoundMessage}</Typography>
      </Container>
    );
  }

  return <>{children}</>;
};

export default LoadingView;
